import api from "../../apis";

export const zaloLogin = async (userId, phoneNumber) => {
  try {
    const response = await api.post("/oauth/zalo/generate", {
      userId: userId,
      phoneNumber: phoneNumber
    });
    return response.data.link;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const zaloOAuthAPI = async (state, code, scope) => {
  try {
    const response = await api.get(`/oauth/zalo?state=${state}&code=${code}&scope=${scope}`);
    return response.data.link;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};